import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import ReactTable from "react-table";
import { toast } from 'react-toastify';
import { fetchStatus } from '../../common/api/dlaapifunctions'
import moment from 'moment';
import 'react-table/react-table.css';
import 'react-toastify/dist/ReactToastify.css';
import { LoadingScreen } from '@nike/ruxac';
import { updateReadyToImportFiles, updateHistoryData, clearDropzoneData, clearAllDataRows, updateInProgressFiles, updateImportedFileStatus } from '../../common/actions/dlaactions'
import './index.scss';
import * as constants from '../../common/filestatus/dlaconstants'
import RecentImportsTable from '../../common/filestatus/recentimporttable'
import { getSignedUrl, sendLoadCompleteMessage, uploadFile } from '../../common/api/dlaapifunctions'
import { createSignedURLPayload, addSchemaErrorInfo } from '../../common/filestatus/helpers'
import appconfig from '../../config/oAuthConfig';
const xlsx= require('xlsx');
const uuidv4 = require('uuid/v4');
const env_name = (typeof process.env.REACT_APP_DATALOADER_APP_ENV !== "undefined") ? process.env.REACT_APP_DATALOADER_APP_ENV : 'dev'
const acceptedFileTypes = constants[appconfig.loaderType].contentType;
const acceptedFileTypesArray = acceptedFileTypes.split(",").map((item) => { return item.trim() })

const fwADAllowedGroups = constants.FW_FOB_EBLB_ALLOWED_GROUP;
const eqADAllowedGroups = constants.EQ_FOB_ALLOWED_GROUP;

class FileUploadStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
        this.refreshId = "";
        
        const groups = this.props.auth.groups;
        console.log("My Groups::", groups);
        if (groups.some(v => fwADAllowedGroups.includes(v))) {
            this.loaderTypes = [constants.ALL_LOADER_TYPES,constants.FOBC_LOADER_TYPE,constants.EB_LB_LOADER_TYPE,constants.CostSheetTrigger_LOADER_TYPE]
        } else if(groups.some(v => eqADAllowedGroups.includes(v))){
            this.loaderTypes = [constants.ALL_LOADER_TYPES,constants.EQ_FOB_LOADER_TYPE]
        }
    }


    componentWillReceiveProps(nextProps) {
        // here droppedfilesData means, newly draged and dropped files.
        let dropedFileData = [];
        if (nextProps.dropzoneFiles.length !== 0) {
            dropedFileData = this.prepareData(nextProps.dropzoneFiles);
            if (this.props.readyToImportFiles.length + dropedFileData.length <= 10) {
                this.props.readyToImportFiles.push(...dropedFileData);
                this.findLoaderType();

            } else {
                toast.error("Maximum size limit exceeded", {
                    autoClose: true
                });

            }

        }

    }

    async refreshImportedFilesStatus () {

        this.props.inProgressFiles.forEach((importedFile, index) => {

            if (importedFile.message === "Import In Progress") {

                fetchStatus("fileId=" + importedFile.uuid, 'Bearer ' + this.props.data.idToken).then((res) => {
                    if (res.data.message[0] && (constants[res.data.message[0].currentStatus] === "Import Failed" || constants[res.data.message[0].currentStatus] === "Import Partially Successful" || constants[res.data.message[0].currentStatus] === "Import Successful")) {
                        importedFile.message = constants[res.data.message[0].currentStatus];
                        let newHistoryData = this.props.historyData;
                        newHistoryData.push(res.data.message[0]);
                        this.props.updateHistoryData(newHistoryData);

                    }
                })

            }
        })
        let inProgressRemain = this.props.inProgressFiles.filter(inProgressFile => inProgressFile.message === "Import In Progress");
        this.props.updateImportedFileStatus(inProgressRemain)

        if (inProgressRemain.length === 0) {
            this.refreshId = clearInterval(this.refreshId);
            this.refreshId = "";
        }
    }

    findLoaderType () {
         this.props.readyToImportFiles.forEach((file) => {
            const reader = new FileReader()
            if (file.status !== "Error") {
                 reader.onload = () => {
                            var workbook = xlsx.read(reader.result, {
                                type: 'binary'
                            });
                            const sheetList = workbook.SheetNames;
                            if (sheetList.length === 1) {
                                let sheetName = sheetList[0];
                                    if(sheetName === constants.FOBC_SHEET_NAME){
                                        file.fileType = constants.FOBC_LOADER_TYPE;                            
                                    } else if (sheetName === constants.EB_LB_SHEET_NAME){
                                        file.fileType = constants.EB_LB_LOADER_TYPE;                               
                                    } else if (sheetName === constants.CostSheetTrigger_SHEET_NAME){
                                        file.fileType = constants.CostSheetTrigger_LOADER_TYPE;                               
                                    } else if (sheetName === constants.QUOTE_DEFERRAL_SHEET_NAME){
                                        file.fileType = constants.QUOTE_DEFERRAL_LOADER_TYPE;                  
                                    } else if (sheetName === constants.EQ_FOB_SHEET_NAME){
                                        file.fileType = constants.EQ_FOB_LOADER_TYPE;                  
                                    }
                                 
                                if(file.fileType === null || file.fileType === "undefined" || file.fileType === "" ){
                                    addSchemaErrorInfo(file, "", constants.INVALID_SHEET_NAME_LABEL)
                                }
                            } else {
                                addSchemaErrorInfo(file, "", constants.INVALID_NUMBER_OF_SHEETS_LABEL)
                            }         
                           this.props.updateReadyToImportFiles(this.props.readyToImportFiles);                    
                    }; 

                file.message = constants.READY_FOR_IMPORT_LABEL;
                file.status = constants.SUCCESS;
                file.readyToLoad = "true";
                file.actionClassName = "fa fa-trash-o";
                this.props.updateReadyToImportFiles(this.props.readyToImportFiles);
            }
            reader.readAsBinaryString(file.fileObject)
        })
    }



    validateFile (currentFile) {
        if (currentFile) {

            const currentFileType = currentFile.type
            console.log("currentFileType...........", currentFileType)
            const currentFileSize = currentFile.size

            let errorMsg = {
                Status: "Inprogress",
                errorMessage: "Identifying Load Type"
            }

            if (!acceptedFileTypesArray.includes(currentFileType)) {

                errorMsg = {
                    Status: "Error",
                    errorMessage: constants.FILE_TYPE_ERROR
                }
                return errorMsg;
            }

            if (currentFileSize > 6291456) {
                errorMsg = {
                    Status: "Error",
                    errorMessage: constants.FILE_SIZE_ERROR
                }
                return errorMsg;
            }

            console.log("currentFile........", currentFile)
            let currentStateFiles = this.props.readyToImportFiles;
            let duplicate = false;
            currentStateFiles.forEach((currentStateFile) => {
                if (currentStateFile.originalFileName === currentFile.name &&
                    currentStateFile.status !== "Proccessed") {
                    duplicate = true;
                }
            })
            if (duplicate) {
                errorMsg = {
                    Status: "Error",
                    errorMessage: constants.DUPLICATE_FILE_ERROR
                }
            }


            return errorMsg
        }
    }


    prepareData (droppedfiles) {

        let dropedFileData = [];
        droppedfiles.forEach((dropfile) => {
            let validationStatus = this.validateFile(dropfile);
            let dropfileDetails = {
                originalFileName: dropfile.name,
                fileType: "",
                status: validationStatus.Status,
                message: validationStatus.errorMessage,
                uploadedTimestamp: moment(new Date()).zone(0).format('L hh:mm A'),
                fileObject: dropfile,
                readyToLoad: "false",
                actionClassName: "fa fa-trash-o",

                uuid: uuidv4()
            }

            dropedFileData.push(dropfileDetails);

        })



        return dropedFileData;



    }

    handleBgColor (row) {

        return row._original.status === "Success" ? "LightGreen" : row._original.status === "loaded" ? "LightGreen" : row._original.status === "Ready" ? "LightGreen" : row._original.status === "Error" ? "Tomato" : row._original.status === "Identifying Load Type" ? "Gold" : row._original.status === "Inprogress" ? "Gold" : row._original.status === "Waiting" ? "LightGrey" : ""
    }

    removeRow (row) {
        const result = this.props.readyToImportFiles.filter(currentDroppedFile => currentDroppedFile.uuid !== row.original.uuid);
        this.props.updateReadyToImportFiles(result);
    }




    preValidation () {

        if (this.props.readyToImportFiles.length === 0) {
            toast.error("There are no files to import.", {
                autoClose: true
            });
            return false;
        }

        if (this.props.readyToImportFiles.length !== 0) {
            let importFiles = this.props.readyToImportFiles.filter(importFile => importFile.status === "Error");
            if (importFiles.length) {
                toast.error("Please remove error files from Pending Imports and Try Import again.", {
                    autoClose: true
                });

                return false;
            }
        }
        return true;
    }

    async loadFiles () {


        if (!this.preValidation()) return;

        this.setState({
            loading: true
        })
        const uuid = uuidv4();
        let inProgressFilesCollection = []
        for(let j = 0; j < this.props.readyToImportFiles.length; j++){        
        
            let signedUrlmsg = createSignedURLPayload(this.props.readyToImportFiles[j], uuid);
            const signedUrls = await getSignedUrl(signedUrlmsg);  //get Singed URLS
            console.log("signedUrls.............",signedUrls);
            
            if (signedUrls) {
                let currentBatchFileSet = [];
                let pcxFileSet = [];
                let fileType;
                const promiseQueue = [];
                for (let i = 0; i < signedUrls.fileList.length; i++) {
                    let signedURLObj = signedUrls.fileList[i]
    
                    for (let m = 0; m < this.props.readyToImportFiles.length; m++) {
    
                        if (signedURLObj.fileName === this.props.readyToImportFiles[m].originalFileName) {
                            let signedURL = signedURLObj.url;
                        
                            let fileSizeInBytes = this.props.readyToImportFiles[m].fileObject.size;
                            fileType=this.props.readyToImportFiles[m].fileType;
                           
                            let uploadPromise = uploadFile(signedURL, this.props.readyToImportFiles[m].fileObject, fileSizeInBytes);
    
                            //will refactor later, changing value directly in props obj may not be good. but it is working.
                            this.props.readyToImportFiles[m].message = "Import In Progress";
                            this.props.readyToImportFiles[m].uuid = signedURLObj.uuid
    
                            // no need to await here.. lets collect all promises. and wait once per batch.
                            promiseQueue.push(uploadPromise);
    
                            let finalFileObject = {
                                "fileName": signedURLObj.fileName,
                                "url": signedURL,
                                "uuid": signedURLObj.uuid,
                                "status": "RDY_FOR_VALIDATION"
    
                            }
                            let pcxFileObject = {
                                "fileName": signedURLObj.fileName,
                                "fileuuid": signedURLObj.uuid,
                                "downloadurl": "https://pcxfe-dataloader-api.s3-us-west-2.amazonaws.com/" + env_name + "/" + signedURLObj.uuid
    
                            }
    
                            currentBatchFileSet.push(finalFileObject);
                            pcxFileSet.push(pcxFileObject);
                            inProgressFilesCollection.push(this.props.readyToImportFiles[m]);
                        }
                    }
   
                }
    
                try {
                    let s3UploadResponse = await Promise.all(promiseQueue); // wait until all files uploaded into S3
                    const result = s3UploadResponse.filter(res => res.status !== 200);
                    if (result && result.length > 0) {
                        toast.error("Unable to Upload Files into PCX., Files will be rejected with Import Failed Status.", {
                            autoClose: true
                        });
                    }
                } catch (error) {
    
                    toast.error("Unable to Upload Files due to network issue, Please contact Administrator", {
                        autoClose: true
                    });
                }
    
                let currentBatch = {
                    "requestID": uuidv4(),
                    "requestData": {
                        "fileList": JSON.parse(JSON.stringify(currentBatchFileSet)),
                        "batchId": signedUrls.batchId,
                        "user": this.props.auth.email,
                        "status": "RDY_FOR_VALIDATION",
                        "fileType": fileType
                    }
                }
    
    
    
                let pcxPayload = {
                    "user": this.props.auth.email,
                    "batchId": signedUrls.batchId,
                    "fileType": fileType,
                    "callback": "https://dataloader-api-" + env_name + ".pcx-test.nike.com/pcx/dla/v1/postProcessCallback",
                    "fileList": JSON.parse(JSON.stringify(pcxFileSet))
                }
    
                console.log("pcxPayload,,,,,,,,,", JSON.stringify(pcxPayload, 0, 4))
                console.log("currentBatch,,,,,,,,,", JSON.stringify(currentBatch, 0, 4))
                sendLoadCompleteMessage(currentBatch);

            }
            else {
                toast.error("Unable to Upload Files, Please contact Administrator", {
                    autoClose: true
                });
            }
        }    
        this.setState({
            loading: false
        })
        this.props.updateInProgressFiles(inProgressFilesCollection) 
       
        // this props help you to track the status.
        if (this.props.inProgressFiles.length !== 0) {
            this.refreshId = setInterval(this.refreshImportedFilesStatus.bind(this), 5000); // track the status every 5 seconds.
        }
    }

    render () {

        const {
            loading
        } = this.state;

        const columns = this.getColumns();
        let importFileTableData = []  // Pending Import Table contains two sets of data, 1. Ready to Import 2. Import In Progress.
        if (this.props.readyToImportFiles.length > 0) {
            importFileTableData.push(...this.props.readyToImportFiles);
        }
        if (this.props.inProgressFiles.length > 0) {
            importFileTableData.push(...this.props.inProgressFiles);
        }
        let pendingImportTableColSizeClass = "col-sm-12";  // In case of Hide Recent Import Table, Pending Import Table shows on Full Screen
        let fileStatusContainerClass = "row"
        let recentImportsTableColSizeClass = "collapse"
        if (this.props.includeHistory === true) {
            fileStatusContainerClass = "row"
            pendingImportTableColSizeClass = "col-sm-7" // Along with  Recent Import Table
            recentImportsTableColSizeClass = "col-sm-5"

        }

        return (

            <div>

                <div className={fileStatusContainerClass}>
                    <div className={pendingImportTableColSizeClass}>
                        <div className="card-header">
                            Pending Imports ({importFileTableData.length})
                            <button type="button" className="btn btn-outline-primary btn-space text-center pull-right" title="Load Files" onClick={() => this.loadFiles()}>Import Files</button>
                            <button type="button" className="btn btn-outline-danger btn-space text-center pull-right" title="Clear Files" onClick={() => this.props.clearAllDataRows()}> Clear Files</button>

                        </div>
                        <div className="card">

                            <small className="card-header">
                                Queued files will be lost if window is refreshed or closed. Click <i>"Import Files"</i> to import data into PCX.

                            </small>

                            <ReactTable
                                defaultPageSize={10}
                                className="-striped -highlight"
                                data={importFileTableData}
                                columns={columns}
                                getTheadThProps={() => {
                                    return {
                                        style: {
                                            background: "LightBlue",
                                            fontWeight: "bold"
                                        }
                                    };
                                }}

                            />
                        </div>
                    </div>


                    <div className={recentImportsTableColSizeClass} >

                        <div className="card">

                            <RecentImportsTable loaderTypes={this.loaderTypes} includeFilter={false} />

                        </div>
                    </div>

                </div>

                <LoadingScreen
                    isLoading={loading}
                    loadingMessage='Loading...' />
            </div >

        );

    }

    getColumns () {
        return [
            {
                accessor: 'uploadedTimestamp',
                Header: 'Date(GMT)',

            },
            {
                Header: 'Load Type',
                maxWidth: 150,
                accessor: 'fileType',
                Cell: row => <div style={{ textAlign: "center" }}>{row.value}</div>
            },
            {
                Header: 'File Name',
                accessor: 'originalFileName'
            }, {
                Header: 'Status',
                accessor: 'message',
                Cell: row => <div style={{ textAlign: "center" }}>{row.value}</div>,
                getProps: (state, rowInfo) => {
                    if (rowInfo && rowInfo.row) {
                        return {
                            style: {
                                background: this.handleBgColor(rowInfo.row)
                            }
                        };
                    }
                    else {
                        return {};
                    }
                }
            }, {
                width: 55,
                Header: "Action",
                accessor: "status",
                headerStyle: { textAlign: 'right' },
                Cell: (row) => (row.value === ("Inprogress") ? <div style={{ textAlign: "center", color: "LightGreen" }}> <div className="spinner-border"></div></div> : <div style={{ textAlign: "center" }}>
                    <button type="button" className="btn btn-default btn-sm" onClick={e => this.removeRow(row)}>
                        <span style={{ fontSize: "20px", textAlign: "right", color: "red" }} className={row.original.actionClassName}></span>

                    </button>
                </div>)
            }
        ];
    }
}

FileUploadStatus.propTypes = {
    data: PropTypes.object.isRequired,
    dropzoneFiles: PropTypes.array,
    finalDataSet: PropTypes.array,
    currentStateLoadFiles: PropTypes.array,
    auth: PropTypes.object

};

const mapDispatchToProps = dispatch => bindActionCreators({

    updateReadyToImportFiles,
    clearDropzoneData,
    clearAllDataRows,
    updateInProgressFiles,
    updateImportedFileStatus,
    updateHistoryData


}, dispatch);

const mapStateToProps = state => ({
    data: state.gCache.data,
    includeHistory: state.dlareducer.includeHistory,
    dropzoneFiles: state.dlareducer.dropzoneFiles,
    readyToImportFiles: state.dlareducer.readyToImportFiles,
    inProgressFiles: state.dlareducer.inProgressFiles,
    historyData: state.dlareducer.historyData,
    auth: state.auth


});
export default React.memo(connect(
    mapStateToProps,
    mapDispatchToProps

)((FileUploadStatus)));
